import { Ellipsis } from 'lucide-react';
import { GBP_CAPTION_LIMIT, GBP_FRAME_ASPECT, GBP_RENDITION, gbpGridRendition } from '../../../../lib/gbp-post-preview';
import { postAuthorName, postMediaGrid } from '../../../../lib/social-post-look-parts';
import { PostAvatar, PostCaption, PostGrid, PostSingleMedia, usePostTiming, useMediaLabel, type SocialPostLookProps } from './SocialPostLookParts';
import styles from './GbpPostPreview.module.css';

export function GbpPostPreview({ card, onOpenMedia, onToggleCaption }: SocialPostLookProps) {
  const label = useMediaLabel(card);
  const grid = postMediaGrid(card);
  const timing = usePostTiming(card);
  const name = postAuthorName(card);
  return (
    <>
      <header className={styles.header}>
        <PostAvatar card={card} name={name} size={30} logoSize={18} />
        <div className={styles.names}>
          <span className={styles.name} data-testid="gbp-business-name">
            <bdi>{name}</bdi>
          </span>
          <span className={timing.scheduled ? styles.when : `${styles.when} ${styles.justNow}`} data-testid="gbp-when">
            {timing.text}
          </span>
        </div>
        <Ellipsis size={24} aria-hidden="true" className={styles.more} data-testid="gbp-more" />
      </header>
      {grid.kind === 'single' && (
        <PostSingleMedia
          key={grid.tile.url}
          media={grid.tile}
          label={label(grid.tile, 0)}
          rendition={GBP_RENDITION}
          className={styles.media}
          testId="gbp-media"
          unmeasured={GBP_FRAME_ASPECT}
          onOpen={() => onOpenMedia(grid.tile, 0)}
        />
      )}
      {grid.kind === 'grid' && (
        <PostGrid grid={grid} label={label} rendition={gbpGridRendition} className={styles.media} testId="gbp-media" onOpen={onOpenMedia} />
      )}
      {card.caption && (
        <PostCaption caption={card.caption} className={styles.caption} testId="gbp-caption" cut={{ limit: GBP_CAPTION_LIMIT }} onToggle={onToggleCaption} />
      )}
    </>
  );
}
